import { useSyncExternalStore } from 'react'

// Whether the current device reports genuine hover + fine-pointer support (i.e. a real
// mouse/trackpad, not a touchscreen). Read via useSyncExternalStore so it's kept in sync
// with matchMedia without the setState-in-effect pattern.
const HOVER_CAPABLE_QUERY = '(hover: hover) and (pointer: fine)'

function subscribe(callback: () => void) {
  const mq = window.matchMedia(HOVER_CAPABLE_QUERY)
  mq.addEventListener('change', callback)
  return () => mq.removeEventListener('change', callback)
}

function getSnapshot() {
  return window.matchMedia(HOVER_CAPABLE_QUERY).matches
}

function getServerSnapshot() {
  return false
}

export function useHoverCapable() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
